import React, { createContext, useContext, useMemo, useState } from "react";

const SettingsSearchContext = createContext({
  query: "",
  setQuery: () => {},
  normalizedQuery: "",
});

export function SettingsSearchProvider({ children }) {
  const [query, setQuery] = useState("");
  const normalizedQuery = query.trim().toLowerCase();
  const value = useMemo(
    () => ({ query, setQuery, normalizedQuery }),
    [query, normalizedQuery],
  );
  return (
    <SettingsSearchContext.Provider value={value}>
      {children}
    </SettingsSearchContext.Provider>
  );
}

export function useSettingsSearch() {
  return useContext(SettingsSearchContext);
}
